/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { last } from 'lodash';

// Mixins
import personPickerMixin from 'ui/mixins/meetings/person-picker';
import prospectHandlingMixin from 'ui/mixins/meetings/prospect-handling';

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import CustomSelect from 'shared/ui/components/form-components/CustomSelect.vue';
import GenericDocExternalPicker from 'shared/ui/components/form-components/pickers/GenericDocExternalPicker.vue';
import ParticipantAvailability from 'ui/components/meetings/meeting-requests/ParticipantAvailability.vue';
import Badge from 'shared/ui/components/Badge.vue';
import { PARTICIPANT_PICKER_LIMIT, PARTICIPANT_PICKER_FIRST_PAGE_LIMIT } from 'shared/libs/utils/constants';

const __vue_script__ = {
    name: 'ParticipantPicker',

    components: { Badge, BaseSelect, CustomSelect, GenericDocExternalPicker, ParticipantAvailability },
    extends: BaseControl,

    mixins: [personPickerMixin, prospectHandlingMixin],

    data() {
        return {
            attrs: {},
            loading: false,
            attendees_script: 'meetings/get-attendees-for-picker',
            attendeesScriptParams: {
                excludeProspects: false,
                withRepresentations: true,
            },
            exclusions: [],
            currentPage: 0,
            itemsOnPage: PARTICIPANT_PICKER_FIRST_PAGE_LIMIT,
        };
    },

    computed: {
        hasNextPage() {
            return this.itemsOnPage < this.innerValue.length;
        },
    },

    methods: {
        hasMissingEmail(doc) {
            return doc?.missing_email ?? false;
        },

        getRepresentation(doc) {
            if (doc?.fp_type === 'prospect') {
                return this.$t('generic_form.external_picker.external_participant');
            }

            if (doc?._representation_line2) {
                return this.$utils.pax.getFullPosition({ company: doc._representation_line2, position: doc._representation_line3 });
            }
        },

        loadNextPage() {
            this.currentPage++;
            this.itemsOnPage = this.itemsOnPage + PARTICIPANT_PICKER_LIMIT;
        },

        setStatuses(statuses) {
            for (const person of this.innerValue) {
                const att = statuses?.find(a => a.fp_owner === person._id);
                this.setPersonAttendance(person, att?.attendance);
                this.setPersonPresence(person, att?.presence);
            }
        },

        ensureDefaultStatuses(input) {
            for (const person of input) {
                this.setPersonAttendance(person);
                this.setPersonPresence(person);
            }
        },

        handleSelect(value) {
            this.$nextTick(() => {
                const lastValue = last(this.innerValue);

                if (value._id === lastValue._id) {
                    const v = this.innerValue.pop();

                    this.innerValue = [v, ...this.innerValue];
                }
            });
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"participant-picker form-group"},[_c('generic-doc-external-picker',_vm._b({attrs:{"emit-key":"_id","fp-type":"person","appscript":_vm.attendees_script,"appscript-extra-params":_vm.attendeesScriptParams,"value-key":"ids","name":_vm.name,"event-id":_vm.event._id,"placeholder":_vm.placeholder,"emit-objects":true,"multiple":true,"sortable":false,"exclusions":_vm.exclusions,"errors":_vm.errors},on:{"input":_vm.ensureDefaultStatuses,"select":_vm.handleSelect},scopedSlots:_vm._u([(_vm.options.actions)?{key:"custom-actions",fn:function(ref){return [_vm._l((_vm.options.actions),function(action){return [(_vm.isActionAllowed(action))?[(action.type === 'anchor')?_c('a',{staticClass:"has-action",attrs:{"href":"#","disabled":_vm.disabled},on:{"click":function($event){!_vm.disabled && _vm.performAction(action)}}},[_vm._v(_vm._s(_vm.$t(action.label)))]):_c('button',{staticClass:"btn btn-mini",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){!_vm.disabled && _vm.performAction(action)}}},[_vm._v(_vm._s(_vm.$t(action.label)))])]:_vm._e()]})]}}:null,{key:"details",fn:function(ref){
var doc = ref.doc;
var remove = ref.remove;
var index = ref.index;
return [(index > _vm.itemsOnPage)?_c('div',{staticClass:"hidden"}):_c('div',{staticClass:"pp_row"},[_c('div',{staticClass:"pp_col doc-details"},[_c('i',{staticClass:"type",class:_vm.$utils.assets.getIconForType('person')}),_c('div',{staticClass:"option"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.getItemLabel(doc)))]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.getRepresentation(doc)))])])]),_c('div',{staticClass:"pp_col"},[_c('div',{staticClass:"pp_col-header"},[_c('label',[_vm._v(_vm._s(_vm.$t('meetings.details.meeting_response')))]),_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:(_vm.$t('meetings.form.hints.meeting_response')),expression:"$t('meetings.form.hints.meeting_response')",modifiers:{"top":true}}],staticClass:"tip ic-info-fill"})]),(doc)?_c('custom-select',{attrs:{"emit-option-value-only":true,"name":(_vm.name + "-acceptance"),"label":_vm.options.acceptance_label,"options":_vm.acceptanceOptions,"allow-empty":false,"disabled":_vm.disabled,"custom":true},scopedSlots:_vm._u([{key:"customOption",fn:function(ref){
var option = ref.option;
return [_c('badge',{attrs:{"config":{ classes: [option.value] }}},[_vm._v(_vm._s(option.label))])]}},{key:"customSingleLabel",fn:function(ref){
var option = ref.option;
return [_c('badge',{attrs:{"config":{ classes: [option.value] }}},[_vm._v(_vm._s(option.label))])]}}],null,true),model:{value:(doc.attendance),callback:function ($$v) {_vm.$set(doc, "attendance", $$v)},expression:"doc.attendance"}}):_vm._e()],1),_c('div',{staticClass:"pp_col wide"},[_c('div',{staticClass:"pp_col-header"},[_c('label',[_vm._v(_vm._s(_vm.$t('meetings.details.set_attendance')))]),_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:(_vm.$t('meetings.form.hints.set_attendance')),expression:"$t('meetings.form.hints.set_attendance')",modifiers:{"top":true}}],staticClass:"tip ic-info-fill"})]),_c('div',{staticClass:"pp_col-body"},[(doc)?_c('base-select',{attrs:{"emit-option-value-only":true,"name":(_vm.name + "-presence"),"allow-empty":false,"label":_vm.options.acceptance_label,"options":_vm.presenceOptions,"disabled":_vm.disabled},model:{value:(doc.presence),callback:function ($$v) {_vm.$set(doc, "presence", $$v)},expression:"doc.presence"}}):_vm._e(),(doc && remove)?_c('div',{staticClass:"pp_actions"},[(doc.fp_type === 'prospect')?_c('a',{staticClass:"edit has-action",attrs:{"href":"#"},on:{"click":function($event){return _vm.onEditProspect(doc._id)}}},[_c('i',{staticClass:"ic-edit"})]):_vm._e(),_c('a',{staticClass:"remove has-action",on:{"click":function($event){return remove()}}},[_c('i',{staticClass:"ic-trash-2"})])]):_vm._e()],1)])]),(_vm.hasMissingEmail(doc))?_c('div',{staticClass:"pp_warning"},[_vm._v(_vm._s(_vm.$t('meetings.form.hints.missing_propsect_email')))]):_vm._e()]}}],null,true),model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'generic-doc-external-picker',_vm.attrs,false)),(_vm.hasNextPage)?[_c('a',{staticClass:"has-action",on:{"click":_vm.loadNextPage}},[_vm._v(_vm._s(_vm.$t('general.show_more')))])]:_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ParticipantPicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__